import React from "react"
import { ISlider, IWidgetSet } from "../../../gatsby-graphql"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import {
  SectionWrapper,
  ContentWrapper,
  LeftCol,
  RightCol,
} from "./slider-with-widgets-elements"
import Slider from "../../components/slider"
import WidgetsSet from "../../components/widgets-set"
import { Heading } from "../../ui"
import { SectionProps } from "../section-loader"

interface SliderWithWidgetsProps extends SectionProps {
  data: {
    leftHeading?: string
    slider?: ISlider
    rightHeading?: string
    widgetSet?: IWidgetSet
  }
}

const SliderWithWidgets = ({ data, locale }: SliderWithWidgetsProps) => {
  return (
    <SectionWrapper>
      <ContentWrapper>
        <LeftCol>
          <Heading.H4 textTransform="uppercase">{data.leftHeading}</Heading.H4>
          {data.slider && <Slider data={data.slider} locale={locale} />}
        </LeftCol>
        <RightCol>
          <Heading.H4 textTransform="uppercase">{data.rightHeading}</Heading.H4>
          {data.widgetSet && <WidgetsSet data={data.widgetSet} locale={locale} />}
        </RightCol>
      </ContentWrapper>
    </SectionWrapper>
  )
}

export default SliderWithWidgets
